module.exports = __webpack_public_path__ + "static/media/s_v5_t1.f5d61cf5.mp3";